export const FEEDBACK_SETTINGS_KEY = "disable_customer_feedbacks";
export const FEEDBACK_SECTION_KEY = "feedback";
export const FEEDBACK_BACK_NAVIGATE_PARAM = "navigate_back";
